import { css } from '@emotion/core';

import { flexStart, SPACE_COMPACT, SPACE_COZY } from '@/styles';

export const actionBarStyles = css`
  padding: ${SPACE_COZY}px;
`;

export const enlargedIconStyles = css`
  transform: scale(1.2);
  ${flexStart};
`;
export const actionFormStyles = css`
  margin-top: -${SPACE_COMPACT}px;
  width: 30%;
`;

// header and row shared styles
export const operationMemberRowStyles = [
  flexStart,
  css`
    & > div {
      &:nth-of-type(1) {
        width: 200px;
        padding-left: ${SPACE_COMPACT}px;
      }
      &:nth-of-type(2) {
        width: 200px;
      }
      &:last-of-type {
        padding-left: ${SPACE_COZY}px;
        width: calc(100% - 400px - ${SPACE_COMPACT}px - ${SPACE_COZY}px);
      }
    }
  `,
];

export const queryStyles = css`
  font-size: 12px;
`;
